// CoinSelector — kebab-style pills: BTC · ETH · SOL · BNB · XRP · ZEC
import React from "react";

const COINS = ["BTC", "ETH", "SOL", "BNB", "XRP", "ZEC"];

export default function CoinSelector({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="liqmap-coin-selector">
      {COINS.map((c) => {
        const active = value === c;
        return (
          <button
            key={c}
            onClick={() => onChange(c)}
            data-testid={`liqmap-coin-${c}`}
            className={
              "rounded-full px-3 py-1.5 font-mono text-[11px] font-black tracking-[0.16em] transition-all " +
              (active
                ? "bg-[#a855f7] text-white shadow-[0_0_18px_rgba(168,85,247,0.45)]"
                : "border border-white/10 bg-white/[0.03] text-white/55 hover:border-[#a855f7]/40 hover:text-white")
            }
          >
            {c}
          </button>
        );
      })}
    </div>
  );
}
